export default "__VITE_ASSET__BCqVu5WE__"